function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.15",
  d: "M3.75 12.75V3.432a.75.75 0 01.374-.649l.745-.431a.75.75 0 01.75-.002l1.128.648L6.75 3l1.12-.65a.746.746 0 01.748 0l1.129.648h.006l1.129-.648a.75.75 0 01.75.002l1.115.646h.006l1.129-.648a.75.75 0 01.75.001l.744.432a.75.75 0 01.374.649v11.193c0 .621-.504 1.125-1.125 1.125v0a1.125 1.125 0 01-1.125-1.125V13.5a.75.75 0 00-.75-.75H3a.75.75 0 00-.75.75v.75a1.5 1.5 0 001.5 1.5h10.875M9.75 9.375H6.753M9.75 6.75H6.753m5.997 2.625H12m.75-2.625H12"
}));